import React from 'react';
import styles from './News.module.css';

const News = () => {
    return (
        <div className={styles.newsContainer}>
             News
        </div>
    )
}

export default News;